import { NumberFormatHandler } from '@/Services/NumberFormatHandler';

/* tslint:disable */
declare global {
  interface Number {
    toDecimalString(locales?: string | string[], type?: string): string;
    toIntegerString(locales?: string | string[]): string;
    toCurrencyString(locales?: string | string[]): string;
    toWeightString(locales?: string | string[]): string;
    toSizeString(locales?: string | string[]): string;
    toPriceString(locales?: string | string[]): string;
    toNormalizeNumber(type: string): string;
  }
}

function getFractionDigitsByType(type = 'integer') {
  switch (type) {
    case 'size':
      return { minimumFractionDigits: 1, maximumFractionDigits: 1 };

    case 'currency':
      return { minimumFractionDigits: 2, maximumFractionDigits: 2 };

    case 'weight':
      return { minimumFractionDigits: 3, maximumFractionDigits: 3 };

    case 'price':
      return { minimumFractionDigits: 4, maximumFractionDigits: 4 };

    default:
      return { minimumFractionDigits: 0, maximumFractionDigits: 0 };
  }
}

Number.prototype.toNormalizeNumber = function (type: string) {
  const number = Number(this);
  const numStr = number.toString();
  const { minimumFractionDigits } = getFractionDigitsByType(type);

  if (isNaN(number)) return '';

  if (type == 'integer') {
    return String(number);
  }

  // Ensure decimal part exists
  if (!numStr.includes('.')) {
    return `${numStr}.${'0'.repeat(minimumFractionDigits)}`;
  }

  const [intPart, decPart = ''] = numStr.split('.');

  // If there are non-zero decimals beyond maxFractionDigits → keep all
  if (!/0+$/.test(decPart)) {
    // Pad to min digits if too short
    const finalDec = decPart.padEnd(minimumFractionDigits, '0');
    return `${intPart}.${finalDec}`;
  }

  // If all zeros → trim but ensure min fraction digits
  const trimmedDec = decPart.replace(/0+$/, '');
  const finalDec = trimmedDec.padEnd(minimumFractionDigits, '0');

  return `${intPart}.${finalDec}`;
};

Number.prototype.toDecimalString = function (locales?: string | string[], type?: string): string {
  const locale = locales ?? NumberFormatHandler.getInstance().getNumberFormatLocales();
  const fractionDigits = getFractionDigitsByType(type);

  return Number(this).toLocaleString(locale, {
    ...fractionDigits,
    maximumFractionDigits: 10,
  });
};

Number.prototype.toIntegerString = function (locales?: string | string[]) {
  const locale = locales ?? NumberFormatHandler.getInstance().getNumberFormatLocales();

  return Number(this).toLocaleString(locale, getFractionDigitsByType('integer'));
};

Number.prototype.toSizeString = function (locales?: string | string[]) {
  const locale = locales ?? NumberFormatHandler.getInstance().getNumberFormatLocales();

  return Number(this).toLocaleString(locale, getFractionDigitsByType('size'));
};

Number.prototype.toCurrencyString = function (locales?: string | string[]) {
  const locale = locales ?? NumberFormatHandler.getInstance().getNumberFormatLocales();

  return Number(this).toLocaleString(locale, getFractionDigitsByType('currency'));
};

Number.prototype.toWeightString = function (locales?: string | string[]) {
  const locale = locales ?? NumberFormatHandler.getInstance().getNumberFormatLocales();

  return Number(this).toLocaleString(locale, getFractionDigitsByType('weight'));
};

Number.prototype.toPriceString = function (locales?: string | string[]) {
  const locale = locales ?? NumberFormatHandler.getInstance().getNumberFormatLocales();

  return Number(this).toLocaleString(locale, getFractionDigitsByType('price'));
};

export {};
